export default __webpack_public_path__ + "static/Sequel-100-Wide-55-d62cad9431d853d7954c61ced8effae3.ttf";